import _extends from "babel-runtime/helpers/extends";
import React from "react";
import styled, { keyframes, css } from "styled-components";

import RoundedButton from '../RoundedButton';

import icon from "./icon.svg";

export var Button = styled(function (props) {
  return React.createElement(RoundedButton, _extends({ size: 60, src: icon, alt: "Informations" }, props));
}).withConfig({
  componentId: "s1a3f0-0"
})(["bottom:0;left:0;"]);

export var PANEL_DURATION_IN_MS = 350;
//# sourceMappingURL=style.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/components/LegalButton/style.js
// module id = 195
// module chunks = 0